export default {
  viewAll: 'すべて表示',
  clearHistory: '履歴をクリア',
  noGamesAvailable: '利用可能なゲームがありません',
  showMore: 'もっと見る',
  showLess: '折りたたむ',
  loading: '読み込み中...',
  error: 'エラー',
  retry: '再試行',
  cancel: 'キャンセル',
  confirm: '確認',
  save: '保存',
  delete: '削除',
  edit: '編集',
  close: '閉じる',
  submit: '送信',
  back: '戻る',
  next: '次へ',
  searchPlaceholder: 'ゲームを検索...',
  search: '検索',
  noMoreGames: 'これ以上のゲームはありません',
  backToTop: 'トップに戻る'
}; 